if (!App.isSSR) {
	$(document).ready(function() {
		$("ul.sideline-navi-list a[href^='#']").on("click", function(event) {
			event.preventDefault();
			const target = this.hash; // eslint-disable-line no-invalid-this

			$(".active-sideline-list").removeClass("active-sideline-list");
			$(".active-sideline-button").removeClass("active-sideline-button");
			$("html, body")
				.stop()
				.animate(
					{
						scrollTop: $(target).offset().top - 150
					},
					900,
					"swing"
				);
		});

		$(".starter-about-navi a[href^='#']").on("click", function(event) {
			event.preventDefault();
			const target = this.hash; // eslint-disable-line no-invalid-this

			$(".active-sideline-list").removeClass("active-sideline-list");
			$(".active-sideline-button").removeClass("active-sideline-button");
			$("html, body")
				.stop()
				.animate(
					{
						scrollTop: $(target).offset().top - 150
					},
					900,
					"swing"
				);
		});
	});
}
